import React from 'react';

import { Card } from './../Card/Card';
import { format } from 'date-fns';
import { RouteElementType } from '../../utils/utils';

export const RouteInfo = ({ route, routeOrders }) => {
  const { name, routeDate, startTime, startPoint, endPoint, driver, loadingAt, endPointArrivalDatetime } = route;

  const signatureAmount = () => (routeOrders.filter((routeOrder) =>
    routeOrder.type === RouteElementType.ROUTE_ORDER && routeOrder.order.haveSignature).length
  );

  const signatureTotalAmount = () => (routeOrders.filter((routeOrder) =>
      routeOrder.type === RouteElementType.ROUTE_ORDER).length
  );

  return (
    <Card title={__('routes.info')}>
        <ul className="list-group">
            <li className="list-group-item">
                {__('routes.route_name')}: <span className="text-bold-700">{name}</span>
            </li>

            <li className="list-group-item">
                Wyjazd o godz.: <span className="text-bold-700">{routeDate}</span>, o{' '}
                <span className="text-bold-700">{startTime}</span>
            </li>
            <li className="list-group-item">
                Wyjazd z: <span className="text-bold-700">{startPoint}</span>
                {endPoint ? (
                    <>
                        , do <span className="text-bold-700">{endPoint}</span>
                    </>
                ) : (
                    <span className="text-muted">, w jedną stronę</span>
                )}
            </li>
            <li className="list-group-item">
                {__('routes.back_at')}: {endPointArrivalDatetime ? (
                <>
                    <span className="text-bold-700">{format(new Date(endPointArrivalDatetime), 'yyyy-MM-dd HH:mm')}</span>
                </>
                ) : (
                    <span className="text-muted text-bold-700">Brak</span>
                )}
            </li>
            <li className="list-group-item">
                Kierowca: {driver ? (
                <>
                    <a href={`/admin/employees/edit/${driver.id}`}>
                        <span className="text-bold-700">{driver.firstName} {driver.lastName}</span>
                    </a>
                </>
            ) : (
                <span className="text-muted text-bold-700">Brak</span>
            )}
            </li>
            <li className="list-group-item">
                {__('routes.vehicle_registration_number')}: {route.car ? (
                <>
                    <span className="text-bold-700">{route.car.name}</span>
                </>
            ) : (
                <span className="text-muted text-bold-700">Brak</span>
            )}
            </li>
            <li className="list-group-item">
                {__('routes.ramp_number')}: {route.rampNumber ? (
                <>
                    <span className="text-bold-700">{route.rampNumber}</span>
                </>
            ) : (
                <span className="text-muted text-bold-700">Brak</span>
            )}
            </li>
            <li className="list-group-item">
                {__('routes.loading_date_time')}: {loadingAt ? (
                <>
                    <span className="text-bold-700">{format(new Date(loadingAt), 'yyyy-MM-dd HH:mm')}</span>
                </>
            ) : (
                <span className="text-muted text-bold-700">Brak</span>
            )}
            </li>

            {route.isReady && (
              <>
                <li className="list-group-item">
                  {__('routes.signatures_amount')}: <span className="text-bold-700">{signatureAmount()} / {signatureTotalAmount()}</span>
                </li>
              </>
            )}
        </ul>
    </Card>
  );
};
